import Dashboard from "./components/Dashboard";

const routes = [
 
  {
    path: 'dashboard',
    name: "داشبورد",
    icon: "fas fa-home nav_icon",
    component: Dashboard,
    layout: "menu",
  },
  {
    path: 'request',
    name: "لیست درخواست",
    icon: "fa fa-list nav_icon",
    component: Dashboard,
    layout: "menu",
  },
  {
    path: 'follow/0' ,
    name: "پیگیری درخواست",
    icon: "fa fa-search nav_icon",
    component: Dashboard,
    layout: "menu",
  },
  
  {
    path: 'profile',
    name: "تنظیمات پروفایل",
    icon: "fa fa-user nav_icon",
    component: Dashboard,
    layout: "menu",
  },


];

export default routes;
